import type { ReactNode } from "react";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import "./Shortlist.scss";

// Fewer than three shortlisted: the customer can add more, or let Edge find the rest when requesting interviews.
const ROUTE = ["", "Add two more, or let Edge find the rest", "Add one more, or let Edge find the last one"];

export function countCardCopy(count: number, cap: number | null): [string, string] {
  // No limit: just how many are on the shortlist.
  if (cap === null) {
    if (count === 0) return ["No one shortlisted yet", "Shortlist anyone you would want to meet from the talent network."];
    return [count === 1 ? "1 person shortlisted" : `${count} people shortlisted`, "Shortlist anyone you would want to meet from the talent network."];
  }
  if (count >= cap) return ["Your shortlist is ready", "Send it to Edge and we will arrange the interviews."];
  if (count === 0) return ["No one shortlisted yet", "Shortlist 3 so we can get an interview booked this week."];
  return [ROUTE[count] || `${cap - count} more to go`, "Shortlist 3 so we can get an interview booked this week."];
}

interface Props {
  count: number;
  /** null = no limit: the count alone, no slots. */
  cap: number | null;
  action?: ReactNode;
  compact?: boolean;
}

function ShortlistCountCard({ count, cap, action = null, compact = false }: Props) {
  const [title, body] = countCardCopy(count, cap);
  const slots = cap === null ? null : Array.from({ length: cap }, (_, i) => <span key={i} className={i < count ? "on" : ""} />);

  return (
    <div className={`sl-count plg-card${compact ? " sl-count--compact" : ""}`}>
      <div className="sl-count__num-wrap">
        {compact && <BookmarkBorderOutlinedIcon className="sl-count__icon" />}
        <div className="sl-count__num">{cap === null ? `${count}` : `${Math.min(count, cap)} of ${cap}`}</div>
        {slots && <div className="plg-slots sl-count__slots">{slots}</div>}
      </div>
      <div className="sl-count__copy">
        <b>{title}</b>
        {body}
      </div>
      {action}
    </div>
  );
}

export default ShortlistCountCard;
